import React, { useState, useEffect } from "react";

const Friends = (props) => {
    const {setLoader, setOpacity,  schoolId, acdYrId, studentId } = props;
    
    const [friend1, setFriend1] = useState("");
    const [friend2, setFriend2] = useState("");
    const [friend3, setFriend3] = useState("");
    const [friend4, setFriend4] = useState("");
    const [friend5, setFriend5] = useState("");

    useEffect(() => {
        // console.log("Friends component loaded");
    }, []);

    const saveFriends = () => {
        // console.log("Saving Friends:", { friend1, friend2, friend3, friend4, friend5 });
    };

    return (
        <div className="col-md-12 col-sm-12 col-xs-12 " style={{ border: "1px solid #ccc", borderRadius: "10px", padding:"10px 0" }}>
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" style={{display:'flex', flexDirection:"column", gap:"10px"}}>
                <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                    <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                        My Friends
                    </label>
                </div>

                {/* Friend 1 */}
                <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                    <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                        <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                            Friend 1
                        </label>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-12 ">
                        <input
                            className="form-control"
                            placeholder="Enter Friend 1"
                            value={friend1}
                            onChange={(e) => setFriend1(e.target.value)}
                        />
                    </div>
                </div>

                {/* Friend 2 */}
                <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                    <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                        <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                            Friend 2
                        </label>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-12 ">
                        <input
                            className="form-control"
                            placeholder="Enter Friend 2"
                            value={friend2}
                            onChange={(e) => setFriend2(e.target.value)}
                        />
                    </div>
                </div>

                {/* Friend 3 */}
                <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                    <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                        <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                            Friend 3
                        </label>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-12 ">
                        <input
                            className="form-control"
                            placeholder="Enter Friend 3"
                            value={friend3}
                            onChange={(e) => setFriend3(e.target.value)}
                        />
                    </div>
                </div>

                {/* Friend 4 */}
                <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                    <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                        <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                            Friend 4
                        </label>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-12 ">
                        <input
                            className="form-control"
                            placeholder="Enter Friend 4"
                            value={friend4}
                            onChange={(e) => setFriend4(e.target.value)}
                        />
                    </div>
                </div>

                {/* Friend 5 */}
                <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                    <div className="col-md-5 col-sm-5 col-xs-12 padding-remove">
                        <label className="control-label text-left col-md-12 col-sm-12 col-xs-12">
                            Friend 5
                        </label>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-12 ">
                        <input
                            className="form-control"
                            placeholder="Enter Friend 5"
                            value={friend5}
                            onChange={(e) => setFriend5(e.target.value)}
                        />
                    </div>
                </div>

                {/* Save Button */}
                <div className="col-md-12 col-sm-12 col-xs-12 padding-remove" style={{margin:"20px 0"}}>
                    <div className="col-md-10 col-sm-10 col-xs-11 padding-remove">
                        <div className="col-md-6 col-sm-6 col-xs-12 pull-right padding-remove">
                            <button className="pull-right btn btn-info" onClick={saveFriends}>
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Friends;
